import { useConfig } from "../../context/config-context";
import { isLecigimonPatient } from "../../utils";

const LECIGIMON_LABELS = {
  levodopa: "LEDD PO",
  apomorphine: "LECIGIMON",
  levoApo: "LEDD PO + LECIGIMON",
};

const TreatmentCard = ({ traitement, patient, className }) => {
  const siteConfig = useConfig();

  const treatmentConfig = siteConfig?.components.treatment_card || {};
  const isLecigimon = isLecigimonPatient(patient);

  return (
    <div
      className={`shadow-xl rounded-xl h-fit${
        className ? " " + className : ""
      }`}
    >
      <div className="p-2 px-3 font-semibold text-white bg-primary rounded-t-xl">
        <label className="uppercase">{treatmentConfig.label}</label>
      </div>
      <div className="bg-white p-3 rounded-b-xl flex flex-col gap-2 min-h-[50px]">
        {treatmentConfig.data.map((item, index) => {
          const label =
            isLecigimon && LECIGIMON_LABELS[item.value]
              ? LECIGIMON_LABELS[item.value]
              : item.label;
          return (
            <div key={index}>
              <label className="font-semibold">{label} : </label>
              <span>
                {item.formatter({
                  value: traitement ? traitement[item.value] : null,
                  removeText: item.removeText,
                  unit: item.unit,
                  key: item.key,
                })}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TreatmentCard;
